<template lang="pug">
  button(:class="{ expanded, single }" @click="$emit('toggle', !expanded)")
    Icon(:name="single ? 'angle-down' : 'expand'" pointer)
</template>

<script>
export default {
  name: 'BtnExpand',
  props: {
    expanded: Boolean,
    single: Boolean,
  },
};
</script>

<style scoped lang="scss">
  button {
    width: 21px;
    height: 23px;
    display: flex;
    justify-content: center;
    align-items: center;
    opacity: .5;
    border: 1px solid #92A0B0;
    border-radius: 4px;
    transition: opacity .1s linear;
    background: transparent;
    cursor: pointer;

    &:not([disabled]):hover {
      opacity: 1;
    }

    &.expanded svg {
      transform: rotate(180deg);
    }

    &.single svg {
      transform: rotate(0deg);
    }

    &.single.expanded svg {
      transform: rotate(180deg);
    }
  }
</style>
